import { colors } from '@kmns-internal/furikake'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { TableActionMenu } from '../TableActionMenu'
import { rowHeadingWidthSx } from '../model'
import { TableColumnHeaderName } from './TableColumnHeaderName'
import type { TableEditHandlers } from './TablePreview'

type BaseProps = {
  /** テンプレート行(`isRepeat = 1`)。名前が見出し列の見出し名になる。 */
  templateRow: TemplateNodeSchema
  hidden: boolean
  /** 多段ヘッダーの全段にまたがる段数。 */
  rowSpan: number
  selected: boolean
}

type InteractiveProps = BaseProps & {
  interactive: true
  handlers: TableEditHandlers
}

type ReadonlyProps = BaseProps & {
  interactive?: false
}

type Props = InteractiveProps | ReadonlyProps

/** 見出し列の列見出し。列見出しと同じく、クリックで選択して下部パネルで編集する。 */
export const TablePreviewRowHeadingHeader = (props: Props) => {
  const { templateRow, hidden, rowSpan, selected } = props

  return (
    <Box
      component="th"
      scope="col"
      rowSpan={rowSpan}
      onClick={
        props.interactive && !hidden
          ? () => props.handlers.onSelectRowHeading(templateRow.id)
          : undefined
      }
      sx={theme => ({
        position: 'sticky',
        top: 0,
        zIndex: 3,
        ...rowHeadingWidthSx(theme, hidden),
        p: 0,
        borderRight: 1,
        borderBottom: 1,
        borderColor: 'divider',
        verticalAlign: 'middle',
        cursor: props.interactive && !hidden ? 'pointer' : 'default',
        bgcolor: selected ? colors.primary.selected : colors.white,
      })}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ width: '100%', minWidth: 0, px: 1.5, py: 0.75 }}
      >
        {hidden ? (
          <Typography
            variant="body2"
            color="text.disabled"
            sx={{ flex: '1 1 auto', textAlign: 'left', whiteSpace: 'nowrap' }}
          >
            見出し非表示
          </Typography>
        ) : (
          <TableColumnHeaderName
            name={templateRow.section?.name?.trim() ?? ''}
          />
        )}
        {props.interactive && (
          <TableActionMenu
            items={[
              {
                key: 'toggle-row-heading-hidden',
                label: hidden ? '見出しを表示する' : '見出しを表示しない',
                onClick: props.handlers.onToggleRowHeadingHidden,
              },
            ]}
            ariaLabel="見出しの操作"
          />
        )}
      </Stack>
    </Box>
  )
}
